// Gentle auto-format (a1): trims and collapses whitespace and capitalizes the first
// letter of each sentence. It NEVER force-lowercases existing text, so acronyms and
// intentional capitals (DAA, RC, NG, etc.) are always preserved.

const capSentences = (s) =>
  s.replace(/(^|[.!?]\s+)([a-z])/g, (m, pre, ch) => pre + ch.toUpperCase());

// Single-line fields: collapse all internal whitespace to one space, trim, capitalize sentences.
export const gentleFormatLine = (s) => {
  const t = (s || "").replace(/[ \t]+/g, " ").trim();
  return t ? capSentences(t) : t;
};

// Multi-line fields: preserve line breaks (cap at 2 consecutive), collapse spaces/tabs
// within each line, trim each line, capitalize sentences per line.
export const gentleFormatMultiline = (s) => {
  if (!s) return s || "";
  return s
    .split("\n")
    .map((line) => {
      const t = line.replace(/[ \t]+/g, " ").trim();
      return t ? capSentences(t) : "";
    })
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};
